export default {
  navigations() {
    const store = require("../store").default; // your vuex store
    var systemTree = Object.assign(
      this.defaultRoutes,
      JSON.parse(JSON.stringify(store.state.systemTree))
    );
    return systemTree;
  },
  parseNavs(item, parent = []) {
    let nav = [];
    const self = this;
    Object.keys(item).forEach((key) => {
      if (item[key].link !== "") {
        if (Object.keys(parent).length > 0) {
          item[key].link =
            (parent.link[0] === "/" ? parent.link : "/" + parent.link) +
            "/" +
            item[key].link;
        }

        item[key].key = key;

        nav.push(item[key]);

        if (Object.keys(item[key].child).length > 0) {
          nav = nav.concat(self.parseNavs(item[key].child, item[key]));
        }
      }
    });
    return nav;
  },
  parseSystemTree(item) {
    const nav = [];
    // var self = this
    // if (!item) item = this.navigations()
    Object.keys(item).forEach((key) => {
      if (item[key].link !== "") {
        const cmp = () =>
          import(
            `@/views/${item[key].view ? item[key].view : "404NotFound.vue"}`
          );

        nav.push({
          path: item[key].link,
          name: item[key].name,
          meta: { title: item[key].name, key: item[key].key },
          redirect:
            typeof item[key].redirect !== "undefined"
              ? item[key].redirect
              : null,
          component: cmp,
          // children: Object.keys(item[key].child).length > 0 ? self.parseSystemTree(item[key].child) : []
        });
      }
    });
    return nav;
  },
  defaultRoutes: {
    login: {
      name: "Login",
      view: "Login.vue",
      link: "/login",
      child: [],
    },
    NotFound: {
      name: "404",
      view: "404NotFound.vue",
      link: "/404",
      child: [],
    },
    "404": {
      redirect: "/404",
      link: "*",
      child: [],
    },
  },
  navs() {
    const parsedNavs = this.parseNavs(this.navigations());
    return this.parseSystemTree(parsedNavs);
  },
  returnNavs() {
    return this.navs();
  },
};

if (module && module.hot) module.hot.accept();
